export default {
      id: "down-arrow-usage",
      viewBox: "0 0 11 7",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#down-arrow",
      toString: function () {
        return this.url;
      }
    }